const getScheduleElements = ({ target }: Event) => {
  if (!target || !('closest' in target)) {
    return null
  }

  try {
    const wrapperRow = (target as HTMLElement).closest('.b-lpu-services__service-wrapper')

    if (!wrapperRow) {
      return null
    }

    const wrapperRowButtonList = [...wrapperRow.querySelectorAll('.b-lpu-services__price')] // Обычная кнопка и кнопка клуба 10%
    const wrapperRowScheduleContainer = wrapperRow.querySelector('.service-prices-schedule')
    const wrapperRowToggleButtonWrapList = [...wrapperRow.querySelectorAll('.b-lpu-services__toggle-calendar-wrap')]
    const allScheduleContainerList = [...document.querySelectorAll('.service-prices-schedule')]
    const allToggleButtonList = [...document.querySelectorAll('.b-lpu-services__toggle-calendar')]
    const allToggleButtonWrapList = [...document.querySelectorAll('.b-lpu-services__toggle-calendar-wrap')]
    const allButtonList = [...document.querySelectorAll('.b-lpu-services__price')]

    return {
      allButtonList,
      allToggleButtonList,
      allToggleButtonWrapList,
      allScheduleContainerList,
      wrapperRowButtonList,
      wrapperRowScheduleContainer,
      wrapperRowToggleButtonWrapList,
    }
  } catch {
    return null
  }
}

export default getScheduleElements
